module.exports = __webpack_public_path__ + "img/boleto.c288aed.svg";